var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlay = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "48px",
  height: "48px",
  viewBox: "0 0 48 48",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "icons/ white / play") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M24,8 C15.1635625,8 8,15.1634375 8,24 C8,32.8365625 15.1635625,40 24,40 C32.8364375,40 40,32.8365625 40,24 C40,15.1634375 32.8364375,8 24,8 Z M29.53,24.848125 L21.53,29.848125 C21.368125,29.9491875 21.1840625,30 21,30 C20.83325,30 20.66625,29.9585 20.515125,29.8745 C20.19725,29.69825 20,29.36375 20,29 L20,19 C20,18.63625 20.19725,18.30175 20.515125,18.1255 C20.833,17.94825 21.2216875,17.959 21.53,18.151875 L29.53,23.151875 C29.82225,23.335 30,23.6553125 30,24 C30,24.3446875 29.82225,24.6650625 29.53,24.848125 Z",
  id: "path-1"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-23.4%",
  y: "-23.4%",
  width: "146.9%",
  height: "146.9%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.147918488 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "icons/-white-/-play",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Shape"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-2)",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFFFFF",
  fillRule: "evenodd",
  xlinkHref: "#path-1"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/play.5dff2b2b400a86d0b9689f84577b048c.svg";